import React from 'react'; // eslint-disable-line
import styled from 'styled-components';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import ToggleButtonGroup from '@mui/lab/ToggleButtonGroup';
import MUIButton from '@mui/material/Button';
import { withTheme } from '@mui/styles';
import { Page as PageUi } from 'shared/components/styled';

export const Page = styled(PageUi)`
  padding: 0px;
  .screen-group {
    background-color: #eaf0f6;
    padding: 24px;
    flex-direction: column;
    align-items: flex-start;
    h2 {
      margin-top: 0px;
      margin-bottom: 12px;
      color: rgb(89, 89, 89);
      font-size: 32px;
      font-weight: 400;
      span {
        color: #99acc2;
        font-size: 24px;
        font-weight: 700;
      }
    }
    .row {
      display: flex;
      flex-direction: row;
      align-items: center;
      .input-title {
        color: rgb(89, 89, 89);
        font-size: 16px;
        font-weight: 700;
        margin-right: 16px;
      }
      .MuiFormControl-root {
        background-color: white;
        height: 48px;
        margin-right: 16px;
        .MuiInputBase-root {
          height: 48px;
        }
      }
    }
  }
`;

export const Root = styled.div`
  position: relative;
  min-height: calc(100vh - 220px);
  margin: 0 20px;
  &.task-root {
    margin: 0px;
    min-height: calc(100vh - 225px);
    box-sizing: border-box;
  }
`;

export const DetailContainer = styled(Paper).attrs({
  elevation: 2,
})`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: 60%;
  overflow-y: auto;
  background-color: white;
  z-index: 100;
`;

export const CalendarContainer = withTheme(styled(Paper)`
  flex: 1 1 auto;
  width: 300px;
  height: 400px;

  .rbc-event {
    background-color: transparent;
    color: rgba(0, 0, 0, 0.8);
    text-align: center;
  }
  .rbc-event.rbc-selected {
    background-color: ${({ theme }) => theme.palette.primary.main};
  }
`);

export const GroupsContainer = styled(Paper)`
  flex: 1 1 auto;
  width: 70%;
  height: 100%;
`;

export const Detail = styled(Box).attrs({
  p: { sm: 2, md: 3 },
})`
  position: relative;
  height: 100%;
`;

export const ExclusiveToggleButtonGroup = styled(ToggleButtonGroup).attrs({
  exclusive: true,
  size: 'small',
  color: 'secondary',
})``;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  label {
    min-width: 150px;
  }
`;

export const Button = styled(MUIButton).attrs({
  variant: 'contained',
})``;

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;

  & *:not(last-child) {
    margin-right: 10px;
  }
`;

export const ButtonSpacer = styled.div`
  width: 16px;
`;

export const SubOption = styled.div`
  padding: 0 32px;
  display: flex;
  & > * {
    flex: 1 1 auto;
  }
  & > *:not(last-child) {
    margin-right: 10px;
  }
`;

const eventBorderColors = {
  overdue: 'red',
  completed: 'lime',
  mixed: 'orange',
  uncompleted: 'rgba(0,0,0,.1)',
};
const eventColors = {
  overdue: 'red',
  completed: 'inherit',
  mixed: 'inherit',
  uncompleted: 'rgba(0,0,0,.5)',
};
const eventBackgroundColors = {
  overdue: 'rgba(255,0,0,.2)',
  completed: 'inherit',
  mixed: 'inherit',
  uncompleted: 'inherit',
};

export const EventView = styled.span`
  border-width: 2px;
  border-style: solid;
  border-color: ${({ status }) => eventBorderColors[status]};
  border-radius: 50%;
  color: ${({ status }) => eventColors[status]};
  background-color: ${({ status }) => eventBackgroundColors[status]};
  padding: 0 5px;
`;

export const GridContainer = styled.div.attrs({
  className: 'ag-theme-material',
})`
  width: 100%;

  .ag-cell,
  .ag-header-cell {
    padding-left: 5px !important;
    padding-right: 5px !important;
    line-height: 24px !important;
  }
`;

export const FilterBox = styled.div`
  min-width: 250px;
`;

/*
const GroupHeaderContainer = styled.div`
  padding: 4px;
  border: 1px solid #CBD6E2;
  ${({ isExpanded }) => isExpanded
    ? `border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      margin: 8px 16px 0 16px;`
    : `border-radius: 4px;
      margin: 8px 16px; height: 36px;
      height: 64px !important;`
  }
  width: calc(100% - 32px) !important;
  display: flex;
  align-items: center;
`
*/

/*
const Title = styled(Typography).attrs({
  variant: 'h6',
  noWrap: true,
})`
  flex: 1 1;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 16px !important;
  color: #0072A2 !important;
  font-weight: bold !important;
`
*/
